import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";

export default function HomeAITransport() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [heights, setHeights] = useState({});
  const refs = useRef([]);

  const items = [
    {
      id: "choose1",
      img: "/assets/images/logistics-new-img1.webp",
      icon: "/assets/images/ai-transport-icon1.webp",
      title: "End-to-End Logistics Orchestration",
      desc: `Coordinate your entire supply chain seamlessly from warehouses to last-mile deliveries, ensuring smooth operations, reduced bottlenecks, and improved efficiency at every stage.`,
      learnLink: "/last-mile-delivery-logistics",
      learntext: "Learn More"
    },
    {
      id: "choose2",
      img: "/assets/images/logistics-new-img2.webp",
      icon: "/assets/images/ai-transport-icon2.webp",
      title: "AI-Native Route Optimization",
      desc: ` Automatically generate the most efficient routes for thousands of orders across hundreds of riders using 200+ constraint parameters in just a few clicks. Minimize delivery times, reduce costs, and boost operational productivity. `,
      learnLink: "/route-optimization-and-planning",
      learntext: "Learn More"
    },
    {
      id: "choose3",
      img: "/assets/images/logistics-new-img3.webp",
      icon: "/assets/images/ai-transport-icon3.webp",
      title: "Smart Carrier Management",
      desc: ` Manage fleets and carriers intelligently with AI-powered insights. Optimize capacity, automate assignments, and ensure timely deliveries with minimal manual intervention.`,
      learnLink: "/transportation-management-services-tms",
      learntext: "Learn More"
    },
  ];

  // calculate height of each panel dynamically
  useEffect(() => {
    const newHeights = {};
    refs.current.forEach((ref, i) => {
      if (ref) {
        newHeights[i] = ref.scrollHeight;
      }
    });
    setHeights(newHeights);
  }, []);

  return (

    <>


      <section className="choose-area space">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-9">
              <div className="choose-text heading-gap">
                <h3 className="heading heading-center ">AI-Based Transport System</h3>
                <p>
                  Our AI-driven transport system transforms logistics operations with smart routing, real-time data, and predictive analytics—empowering faster, smarter deliveries and informed decision-making across the supply chain.

                </p>
              </div>
            </div>

            <div className="choose-row">
              <div className="row align-items-start">
                <div className="col-lg-6 col-md-12">
                  <div className="choose-accord">
                    {items.map((item, index) => (
                      <div key={index} className={`card ${activeIndex === index ? "active" : ""}`}  >
                        <div className="card-header">
                          <button className={`btn-items ${activeIndex === index ? "" : "collapsed"}`} onClick={() => setActiveIndex(activeIndex === index ? -1 : index)}  >
                            <label>
                              <img src={item.icon} className="img-responsive" alt={item.title} loading="lazy" />
                            </label>
                            {item.title}
                          </button>
                        </div>

                        <div ref={(el) => (refs.current[index] = el)} className={`collapse-panel ${activeIndex === index ? "open" : ""}`} style={{ height: activeIndex === index ? `${heights[index] || "auto"}px` : "0px", }}   >
                          <div className="card-body">
                            <p>{item.desc}</p>
                            <div className="learn-more-btns">
                              <Link className="learn-more" to={item.learnLink}> <span>{item.learntext}</span>  </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="col-lg-6 col-md-12">
                  <div className="choose-image">
                    {items.map((item, index) => (
                      <div key={index} id={item.id} className={`choose-reason ${activeIndex === index ? "active" : "d-none"}`}  >
                        <img src={item.img} className="img-responsive" alt={item.title} loading="lazy" />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="border-left">
        <span></span>
      </div>
    </>

  );
}
